import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-commerces',
    templateUrl: './commerces.component.html',
    styleUrls: ['./commerces.component.scss']
})

export class CommercesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville'/*, 'france'*/];

    /**
     * Chart repartition
     */
    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['Grande distribution', 'Santé', 'Shopping', 'Commerces de proximité', 'Magasins pour la maison', 'Autres']
        },
        calculable: true,
    };


    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }


    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.commerce_iris[this.iris]) {
            irisData = this.favorite.ad_city.commerce_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.commerce_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.commerce_gq[this.secteur];
        }

        let root = this.favorite.ad_city.commerce;
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: 'Commerces',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],

                    data: [
                        {value: Math.round(root.tot_com), name: (Math.round(root.tot_com)).toString() + '\nCommerces'},
                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['55%', '80%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],
                    data: [
                        {
                            value: Math.round(root.hypmar + root.supmar + root.surge),
                            name: 'Grande distribution'
                        },
                        {
                            value: Math.round(root.opt + root.medi + root.pharma),
                            name: 'Santé'
                        },
                        {
                            value: Math.round(root.sport + root.vet + root.chaus),
                            name: 'Shopping'
                        },
                        {
                            value: Math.round(root.boulan + root.epice + root.poisson + root.supe + root.bouch),
                            name: 'Commerces de proximité'
                        },
                        {
                            value: Math.round(root.brico + root.droguerie + root.electro + root.equ + root.revet + root.meub),
                            name: 'Magasins pour la maison'
                        },
                        {
                            value: Math.round(root.essence + root.fleur + root.horlog + root.lib + root.parfum),
                            name: 'Autres'
                        },
                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['85%', '95%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5,
                    },
                    color: [],
                    data: []
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        // Grande distribution
        if (root.hypmar) {
            this.data.series[2].data.push({value: Math.round(root.hypmar), name: 'Hypermarchés'});
            this.data.series[2].color.push('#1F98D2');
        }

        if (root.supmar) {
            this.data.series[2].data.push({value: Math.round(root.supmar), name: 'Supermarchés'});
            this.data.series[2].color.push('#42AFE4');
        }

        if (root.surge) {
            this.data.series[2].data.push({value: Math.round(root.surge), name: 'Produits surgelés'});
            this.data.series[2].color.push('#91D5F6');
        }

        // Santé
        if (root.opt) {
            this.data.series[2].data.push({value: Math.round(root.opt), name: 'Opticiens'});
            this.data.series[2].color.push('#418A11');
        }

        if (root.medi) {
            this.data.series[2].data.push({value: Math.round(root.medi), name: 'Cabinets medicaux'});
            this.data.series[2].color.push('#5CB125');
        }

        if (root.pharma) {
            this.data.series[2].data.push({value: Math.round(root.pharma), name: 'Pharmacies'});
            this.data.series[2].color.push('#BDED9E');
        }

        // Shopping
        if (root.sport) {
            this.data.series[2].data.push({value: Math.round(root.sport), name: 'Magasins de sport'});
            this.data.series[2].color.push('#B27805');
        }

        if (root.vet) {
            this.data.series[2].data.push({value: Math.round(root.vet), name: 'Magasins de vetements'});
            this.data.series[2].color.push('#E9A00E');
        }

        if (root.chaus) {
            this.data.series[2].data.push({value: Math.round(root.chaus), name: 'Magasins de chaussure'});
            this.data.series[2].color.push('#FFCA61');
        }

        // Commerces de proximités
        if (root.boulan) {
            this.data.series[2].data.push({value: Math.round(root.boulan), name: 'Boulangeries'});
            this.data.series[2].color.push('#04496B');
        }

        if (root.epice) {
            this.data.series[2].data.push({value: Math.round(root.epice), name: 'Epiceries'});
            this.data.series[2].color.push('#065E89');
        }

        if (root.poisson) {
            this.data.series[2].data.push({value: Math.round(root.poisson), name: 'Poissonneries'});
            this.data.series[2].color.push('#1277AA');
        }

        if (root.supe) {
            this.data.series[2].data.push({value: Math.round(root.supe), name: 'Superrettes'});
            this.data.series[2].color.push('#3389B3');
        }

        if (root.bouch) {
            this.data.series[2].data.push({value: Math.round(root.bouch), name: 'Boucheries'});
            this.data.series[2].color.push('#57A1C5');
        }

        // Magasins pour la maison
        if (root.droguerie) {
            this.data.series[2].data.push({value: Math.round(root.droguerie), name: 'Drogueries'});
            this.data.series[2].color.push('#373636');
        }

        if (root.electro) {
            this.data.series[2].data.push({value: Math.round(root.electro), name: 'Magasins d\'électroménager'});
            this.data.series[2].color.push('#6F6F6F');
        }

        if (root.equ) {
            this.data.series[2].data.push({value: Math.round(root.equ), name: 'Magasins d\'équipements du foyer'});
            this.data.series[2].color.push('#9C9C9C');
        }

        if (root.revet) {
            this.data.series[2].data.push({value: Math.round(root.revet), name: 'Magasins de revêtements murs et sols'});
            this.data.series[2].color.push('#C3C3C3');
        }

        if (root.meub) {
            this.data.series[2].data.push({value: Math.round(root.meub), name: 'Magasins de meubles'});
            this.data.series[2].color.push('#C7C7C7');
        }

        // Autre
        if (root.fleur) {
            this.data.series[2].data.push({value: Math.round(root.fleur), name: 'Fleuristes'});
            this.data.series[2].color.push('#BE1111');
        }

        if (root.horlog) {
            this.data.series[2].data.push({value: Math.round(root.horlog), name: 'Horlogeries bijouteries'});
            this.data.series[2].color.push('#EB2D2D');
        }

        if (root.lib) {
            this.data.series[2].data.push({value: Math.round(root.lib), name: 'Libraries'});
            this.data.series[2].color.push('#FF5455');
        }

        if (root.parfum) {
            this.data.series[2].data.push({value: Math.round(root.parfum), name: 'Parfumeries'});
            this.data.series[2].color.push('#FF7777');
        }

        if (root.essence) {
            this.data.series[2].data.push({value: Math.round(root.essence), name: 'Stations-service'});
            this.data.series[2].color.push('#FFA2A2');
        }

        this.compare = [
            {
                'lib': 'Commerces',
                'quartier': (irisData != null ? irisData.tot_com : '-'),
                'secteur': (secteurData != null ? secteurData.tot_com : '-'),
                'ville': this.favorite.ad_city.commerce.tot_com,
                // 'france': this.favorite.ad_city.commerce_fr.tot_com,
            },
            {
                'lib': 'Grande distribution',
                'quartier': (irisData != null ? irisData.hypmar + irisData.supmar + irisData.surge : '-'),
                'secteur': (secteurData != null ? secteurData.hypmar + secteurData.supmar + secteurData.surge : '-'),
                'ville': this.favorite.ad_city.commerce.hypmar + this.favorite.ad_city.commerce.supmar + this.favorite.ad_city.commerce.surge,
                // 'france': this.favorite.ad_city.commerce_fr.hypmar + this.favorite.ad_city.commerce_fr.supmar + this.favorite.ad_city.commerce_fr.surge,
            },
            {
                'lib': 'Santé',
                'quartier': (irisData != null ? irisData.opt + irisData.medi + irisData.pharma : '-'),
                'secteur': (secteurData != null ? secteurData.opt + secteurData.medi + secteurData.pharma : '-'),
                'ville': this.favorite.ad_city.commerce.opt + this.favorite.ad_city.commerce.medi + this.favorite.ad_city.commerce.pharma,
                // 'france': this.favorite.ad_city.commerce_fr.opt + this.favorite.ad_city.commerce_fr.medi + this.favorite.ad_city.commerce_fr.pharma,
            },
            {
                'lib': 'Shopping',
                'quartier': (irisData != null ? irisData.sport + irisData.vet + irisData.chaus : '-'),
                'secteur': (secteurData != null ? secteurData.sport + secteurData.vet + secteurData.chaus : '-'),
                'ville': this.favorite.ad_city.commerce.sport + this.favorite.ad_city.commerce.vet + this.favorite.ad_city.commerce.chaus,
                // 'france': this.favorite.ad_city.commerce_fr.sport + this.favorite.ad_city.commerce_fr.vet + this.favorite.ad_city.commerce_fr.chaus,
            },
            {
                'lib': 'Commerces de proximité',
                'quartier': (irisData != null ? irisData.boulan + irisData.epice + irisData.poisson + irisData.supe + irisData.bouch : '-'),
                'secteur': (secteurData != null ? secteurData.boulan + secteurData.epice + secteurData.poisson + secteurData.supe + secteurData.bouch : '-'),
                'ville': this.favorite.ad_city.commerce.boulan + this.favorite.ad_city.commerce.epice + this.favorite.ad_city.commerce.poisson + this.favorite.ad_city.commerce.supe + this.favorite.ad_city.commerce.bouch,
                // 'france': this.favorite.ad_city.commerce_fr.boulan + this.favorite.ad_city.commerce_fr.epice + this.favorite.ad_city.commerce_fr.poisson + this.favorite.ad_city.commerce_fr.supe + this.favorite.ad_city.commerce_fr.bouch,
            },
            {
                'lib': 'Magasins pour la maison',
                'quartier': (irisData != null ? irisData.brico + irisData.droguerie + irisData.electro + irisData.equ + irisData.revet + irisData.meub : '-'),
                'secteur': (secteurData != null ? secteurData.brico + secteurData.droguerie + secteurData.electro + secteurData.equ + secteurData.revet + secteurData.meub : '-'),
                'ville': this.favorite.ad_city.commerce.brico + this.favorite.ad_city.commerce.droguerie + this.favorite.ad_city.commerce.electro + this.favorite.ad_city.commerce.equ + this.favorite.ad_city.commerce.revet + this.favorite.ad_city.commerce.meub,
                // 'france': this.favorite.ad_city.commerce_fr.brico + this.favorite.ad_city.commerce_fr.droguerie + this.favorite.ad_city.commerce_fr.electro + this.favorite.ad_city.commerce_fr.equ + this.favorite.ad_city.commerce_fr.revet + this.favorite.ad_city.commerce_fr.meub,
            },
            {
                'lib': 'Autres',
                'quartier': (irisData != null ? irisData.essence + irisData.fleur + irisData.horlog + irisData.lib + irisData.parfum : '-'),
                'secteur': (secteurData != null ? secteurData.essence + secteurData.fleur + secteurData.horlog + secteurData.lib + secteurData.parfum : '-'),
                'ville': this.favorite.ad_city.commerce.essence + this.favorite.ad_city.commerce.fleur + this.favorite.ad_city.commerce.horlog + this.favorite.ad_city.commerce.lib + this.favorite.ad_city.commerce.parfum,
                // 'france': this.favorite.ad_city.commerce_fr.essence + this.favorite.ad_city.commerce_fr.fleur + this.favorite.ad_city.commerce_fr.horlog + this.favorite.ad_city.commerce_fr.lib + this.favorite.ad_city.commerce_fr.parfum,
            },
        ]
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
